import { EVASION } from '../../character/content/templates';

export default function CombatWheelchair() {
    return (
        <>
            <p>The combat wheelchair is a ruleset designed to help you play a wheelchair user in Daggerheart. This section provides mechanics
                and narrative guidance for you to work from, but feel free to adapt the flavor text to best suit your character. Have fun with your
                character's wheelchair design, and make it as unique or tailored to them as you please.</p>
            <h3>ACTION AND MOVEMENT</h3>
            <p>When describing how your character moves, you can use
                descriptions such as the following:</p>
            <ul>
                <li>“I roll over to the door to see if it's open.”</li>
                <li>“I wheel myself over to the group to ask what's going on.”</li>
                <li>“I pull my brakes and skid to a halt, turning in my seat to level my bow at the intruder.”</li>
            </ul>
            <h3>CONSEQUENCES</h3>
            <p>Here are some ways you might describe complications you
                encounter when your character uses their wheelchair:</p>
            <ul>
                <li>“I pull my brakes, but I don't think to account for the loose
                    gravel on the ground.”</li>
                <li>“I hit a patch of ice awkwardly and am sent skidding out
                    past my target.”</li>
                <li>“I go to push off in pursuit, but one of my front caster
                    wheels snags on a crack in the pavement, stalling me for a
                    moment.”</li>
            </ul>
            <p>GMs should avoid breaking a character's wheelchair or
                otherwise removing it from play as a consequence, unless
                everyone at the table, especially the wheelchair user's player,
                gives their approval.
            </p>
            <h3>{EVASION}</h3>
            <p>Your character is assumed to be skilled in moving their
                wheelchair and navigating numerous situations in it. As a
                result, the only wheelchair that gives a penalty to a PC's
                {EVASION} is the Heavy Frame model.</p>
            <h3>BURDEN</h3>
            <p>All wheelchairs can be maneuvered using one or two hands
                outside of combat. However, when being used as a weapon,
                the chair is restricted to requiring one or two hands to
                perform attacks, depending on the model you've chosen. If
                you're playing a character who has limited to no mobility in
                their arms, their wheelchair can be attuned to them by magical
                means. For example, your character might use a psychic link
                to guide the chair around like a pseudo-electric wheelchair. All
                the rules presented here can be tailored and adapted to any
                character's needs.</p>
            <h3>CHOOSE YOUR MODEL</h3>
            <p>All combat wheelchairs are equipped as Primary Weapons.
                There are three models of wheelchair available: light, heavy,
                and arcane. You're encouraged to consider the type of
                character you're playing and the class they belong to, then
                choose the model that best matches that character concept.
            </p>
        </>
    );
}